import React, {useEffect, useMemo} from 'react'
import {Bar} from "react-chartjs-2";
import {useDispatch, useSelector} from "react-redux";
import {fetchGraphTwo} from "../../redux/actions";
import {useTranslation} from "react-i18next";

const GraphTwo = ({settings}) => {

    const {t} = useTranslation()
    const dispatch = useDispatch()
    const graphFetchedData = useSelector(state => state.analytics.top_clients)

    useEffect(() => {
        dispatch(fetchGraphTwo())
    }, [])

    const Two = useMemo(() => {
        return (
            <Bar className="graph top-clients-graph"
                  data={{
                      labels: graphFetchedData.allClients,
                      datasets: [
                          {
                              label: 'Cars rented by a user',
                              data: graphFetchedData.numberOfRentedCarsOfClient,
                              backgroundColor: 'royalblue',
                              hoverBackgroundColor: 'royalblue',
                              borderColor: 'rgb(0, 0, 255)',
                              pointBackgroundColor: 'cyan',
                              tension: 0.4,
                              fill: true
                          }
                      ]
                  }}
                  options={
                      {
                          ...settings,
                          maintainAspectRatio: true
                      }}
            />
        )
    }, [graphFetchedData])

    return (
        <>
            <div className="chart-info">
                <h2>{t('graphTwoTitle')}</h2>
                <p className="descr">{t('graphTwoDescription')}</p>
            </div>
            {Two}
        </>
    )
}

export default React.memo(GraphTwo)